import React from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import { Listings } from 'containers/AppContainer/typings';
import { LISTINGS } from 'containers/data-structure';
import { get, isEmpty } from 'lodash';
import { EXPERTISE_FIELD } from 'containers/common/LegalProceedings/JudgementAdd/Forms/JudgementAddPrononcings/constants';
import { shouldRenderExpertiseByType } from 'containers/common/LegalProceedings/ExpertReport/utils';
import { IUploadedDocument } from 'containers/LawyerLegalProceedingsPage/typings';
import {
  ExpertReportType,
  IExpertGlobalReportState,
} from 'containers/common/LegalProceedings/ExpertReport/typings';
import { Container } from 'containers/TransactionManagerTimeLine/ContactVictim/style';
import ExpertiseType from 'containers/common/LegalProceedings/JudgementAdd/Recap/Pronouncing/Expertise/ExpertiseType';
import ExpertiseVictims from 'containers/common/LegalProceedings/JudgementAdd/Recap/Pronouncing/Expertise/Victims';
import ExpertiseByType from 'containers/common/LegalProceedings/ExpertReport/ExpertiseByType';
import { TYPE } from 'containers/common/LegalProceedings/ExpertReport/FormsByExpertiseType/constants';
import { getCurrentExpertise } from 'containers/common/LegalProceedings/ExpertReportAppeal/utils';
import { Claim } from 'containers/PreOpeningPage/typings';
import { VictimType } from 'typings/globalTypes';

export interface ExpertRecapProps {
  intl: IntlShape;
  expertReportState: IExpertGlobalReportState[];
  listings: Listings;
  uploadDocument?: Function;
  uploadedDocument?: IUploadedDocument;
  resetUploadedDocument?: Function;
  documentId?: string;
  setDocumentId?: Function;
  claimId: number;
  readOnly?: boolean;
  isManager?: boolean;
  expertReport: ExpertReportType;
  setIsDecisionDialgOpen?: Function;
  setExpertReportState: Function;
  isDecisionDialgOpen?: boolean;
  validateVictimExpertise?: any;
  documentIndex: number;
  expertises: any;
  isRecap?: boolean;
  isAssignedLawyer: boolean;
  isCreator?: boolean;
  deactivateButton?: any;
  setDeactivateButton?: Function;
  judgementAddDocuments?: any;
  setIsSuccessPopinOpen?: Function;
  victimExpertises?: any;
  vehicleExpertises?: any;
  requestCreateExpertiseRaport?: Function;
  requestValidateExpertReport?: Function;
  requestGetExpertiseRaport?: Function;
  claimNumber: string;
  judiciaryProcessId?: number;
  assignedLawyers?: string[];
  claim?: Claim;
  victims?: VictimType[];
  policyInfo?: any;
  hasJom?: boolean;
  sagisVictimInfo: any;
  sagisOpposingParties: any;
  isBasicManagement?: boolean;
  imagineDocuments: any;
  requestGetDocByDocumentumId: Function;
}

export const ExpertRecap: React.FC<ExpertRecapProps> = (props): JSX.Element => {
  return (
    <Container>
      {props.expertises.map((expertise: any, expertiseIndex: number) => (
        <ExpertiseType
          expertiseId={expertise[EXPERTISE_FIELD.EXPERTISE_ID]}
          expertiseList={get(props.listings, LISTINGS.EXPERTISE, [])}
          index={expertiseIndex}
          key={expertiseIndex}
        >
          <>
            {shouldRenderExpertiseByType(
              expertise[EXPERTISE_FIELD.EXPERTISE_ID],
            ).shouldRenderVictimFields && (
              <ExpertiseVictims victims={expertise.victims}>
                {expertise.victims
                  .filter(
                    (victim: any) => !isEmpty(get(victim, 'victimExpertise')),
                  )
                  .map((victim: any, victimIndex: number) => (
                    <ExpertiseByType
                      expertReport={props.expertReport}
                      listings={props.listings}
                      documentId={props.documentId}
                      setDocumentId={props.setDocumentId}
                      uploadDocument={props.uploadDocument}
                      uploadedDocument={props.uploadedDocument}
                      resetUploadedDocument={props.resetUploadedDocument}
                      expertReportState={props.expertReportState}
                      setExpertReportState={props.setExpertReportState}
                      validateVictimExpertise={props.validateVictimExpertise}
                      isAssignedLawyer={props.isAssignedLawyer}
                      isCreator={props.isCreator}
                      deactivateButton={props.deactivateButton}
                      setDeactivateButton={props.setDeactivateButton}
                      judgementAddDocuments={props.judgementAddDocuments}
                      setIsSuccessPopinOpen={props.setIsSuccessPopinOpen}
                      expertise={expertise}
                      item={victim}
                      index={victimIndex}
                      documentIndex={props.documentIndex}
                      expertiseIndex={expertiseIndex}
                      expertiseType={TYPE.VICTIM}
                      currentExpertise={getCurrentExpertise(
                        props.victimExpertises,
                        props.vehicleExpertises,
                        victim.id,
                        expertise.expertiseId,
                        expertise.expertiseJudgementAddDocumentId,
                      )}
                      claimId={props.claimId}
                      requestCreateExpertiseRaport={
                        props.requestCreateExpertiseRaport
                      }
                      requestValidateExpertReport={
                        props.requestValidateExpertReport
                      }
                      judiciaryProcessId={props.judiciaryProcessId}
                      claimNumber={props.claimNumber}
                      requestGetExpertiseRaport={
                        props.requestGetExpertiseRaport
                      }
                      isAppeal={false}
                      isRecap={props.isRecap}
                      isManager={props.isManager}
                      setIsDecisionDialgOpen={props.setIsDecisionDialgOpen}
                      isDecisionDialgOpen={props.isDecisionDialgOpen}
                      assignedLawyers={props.assignedLawyers}
                      claim={props.claim}
                      victims={props.victims}
                      policyInfo={props.policyInfo}
                      hasJom={props.hasJom}
                      sagisVictimInfo={props.sagisVictimInfo}
                      sagisOpposingParties={props.sagisOpposingParties}
                      isBasicManagement={props.isBasicManagement}
                      imagineDocuments={props.imagineDocuments}
                      expertiseRaportFirstInstance={{}}
                      requestGetDocByDocumentumId={
                        props.requestGetDocByDocumentumId
                      }
                    />
                  ))}
              </ExpertiseVictims>
            )}
          </>
        </ExpertiseType>
      ))}
    </Container>
  );
};

export default injectIntl(ExpertRecap);
